/**
 * Call services
 * 
 * 
 */

import {get, getR, getSync, apiURL, currentLang} from './functions';
import axios from 'axios';
import flatstore from 'flatstore';

/**
 * Get Menu
 * 
 */
export const getMenu = (slug, data_name) => {
    let url = apiURL()+"/menu/"+slug+"-"+currentLang();
    getR(url, data_name);
}

/**
 * Get FAQ data
 * 
 */
export const getFAQ = () => {
    let url = apiURL()+"/faq";
    get(url, 'faq_data');
}

/**
 * Get Farmers List
 * 
 */
export const getFarmers = (page=1) => {
    let url = apiURL()+"/farmers"; //?page="+page;
    get(url, 'farmers_data');
}

/**
 * Get Farmer Full
 * 
 */
export const getFarmerInfo = (slug) => {
    let url = apiURL()+"/farmers/"+slug;
    getSync(url, 'farmer_data');
}

/**
 * Get Breeds List
 * 
 */
export const getBreeds = (page=1) => {
    let url = apiURL()+"/breeds"; //?page="+page;
    get(url, 'breeds_data');
}

/**
 * Get Breed Full
 * 
 */
export const getBreedInfo = (slug) => {
    let url = apiURL()+"/breeds/"+slug;
    getSync(url, 'breed_data');
}

/**
 * Get Recipes List
 * 
 */
export const getRecipes = (page=1) => {
    let url = apiURL()+"/recipes";
    get(url, 'recipes_data');
}


/**
 * Get Recipe Full
 * 
 */
export const getRecipeInfo = (slug) => {
    let url = apiURL()+"/recipes/"+slug;
    getSync(url, 'recipe_data');
}


/**
 * Get Product List
 * 
 */
export const getProducts = () => {
    let url = apiURL()+"/products";
    getR(url, 'products_data');
}

/**
 * Get Product Info
 * 
 */
export const getProductInfo = (slug) => {
    let url = apiURL()+"/products/"+slug;
    get(url, 'product_data');
}

/**
 * Get Product Info Sync
 * 
 */
export const getProductInfoSync = (slug) => {
    let url = apiURL()+"/products/"+slug;
    getR(url, 'product_data');
}

/**
 * with loading
 */
export const getStatic = (slug, data_name) => {
    let url = apiURL()+"/statics/"+slug;
    get(url, data_name);
}

/**
 * with loading sync
 */
export const getStaticSync = (slug, data_name) => {
    let url = apiURL()+"/statics/"+slug;
    getSync(url, data_name);
}

/**
 * with loading sync
 */
export const getMeatcutSync = (slug) => {
    let url = apiURL()+"/meatcuts/"+slug;
    getSync(url, 'meatcut_data');
}

/**
 * without loading
 */
export const getStaticPage = (slug, data_name) => {
    let url = apiURL()+"/statics/"+slug;
    getR(url, data_name);
}

/**
 * Basket Count
 */
export const getBasketCount = () => {
    var href = window.location.href;
    var base_url = process.env.REACT_APP_SHOP_URL;
    if(href.includes('local')){
        base_url = 'https://alpha.grutto.com';
    }else if(href.includes('alpha')){
        base_url = 'https://alpha.grutto.com';
    }else if(href.includes('staging')){
        base_url = 'https://staging.grutto.com';
    }
    let url = base_url+"/"+currentLang()+"/shop/grutto-cart-data.php";
    axios.get(url, {}).then(function(response){
        flatstore.set('basket_count', response.data); 
    });
}

/**
 * Get settings
 */
export const getSettings = (slug) => {
    let url = apiURL()+"/settings/"+slug;
    getR(url, 'settings_data');
}

export const getRelatedProducts = (type, slug) => {
    let url = apiURL()+"/products/"+type+"/"+slug;
    getR(url, 'related_products_data');
}

export const getRelatedRecipes = (type, slug) => {
    let url = apiURL()+"/recipes/"+type+"/"+slug;
    getR(url, 'related_recipes_data');
}

export const getMeatcuts = (animalId) => {
    let url = apiURL()+"/meatcuts/animal/"+animalId;
    getR(url, 'meatcuts_data');
}

export const getCoupons = () => {
    let url = apiURL()+"/coupons";
    get(url, 'coupons_data');
}
